import { Stack, Image, IImageProps, ImageFit, Text } from '@fluentui/react';
import React from 'react';
import img from '../../assets/errorPage.jpg'
interface NoClientProps {

}

export default (props: NoClientProps): JSX.Element => {
  const imageProps: IImageProps = {
    src: img,
    imageFit: ImageFit.contain,
  };

  return (
    <Stack horizontalAlign='center' verticalAlign='center' style={{ width: '100%', height: '100%', background: '#F5F5F5' }}>
      <Image
        {...imageProps}
        width={280}
        height={200}
        alt="暂无接入，休息一下吧"
      />
      <Text style={{ color: '#484644', marginTop: '32px', fontSize: '18px' }}>暂无接入，休息一下吧！</Text>
    </Stack>
  );
};
